export const styles = {
  mainContainerStyle: {
    margin: "0 auto",
    padding:
      window.innerWidth > 1200
        ? "0 20%"
        : window.innerWidth > 900
        ? "0 15%"
        : window.innerWidth > 700
        ? "0 10%"
        : "0 5%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
};
